import React from "react";
import { Grid, Menu, type Icon as FeatherIcon } from "react-feather";
import type { ControlSizeKey } from "../../../design-system/tokens/controlSizes";
import { ToggleShell, SegmentButton } from "./ViewModeToggle.styles";
import type { ViewModeToggleProps, ViewMode } from "./ViewModeToggle.types";

const SEGMENTS: Array<{ mode: ViewMode; label: string; Icon: FeatherIcon }> = [
  { mode: "grid", label: "Grid view", Icon: Grid },
  { mode: "list", label: "List view", Icon: Menu },
];

/**
 * Icon size per density step. Tuned so the icon visually fills the segment
 * without crowding it (Figma uses 24px at md to match the 32px segment).
 */
const ICON_SIZE_PX: Record<ControlSizeKey, number> = {
  sm: 16,
  md: 24,
  lg: 28,
};

export const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  value,
  onChange,
  size = "md",
  className,
}) => (
  <ToggleShell
    $size={size}
    className={className}
    role="group"
    aria-label="View mode"
  >
    {SEGMENTS.map(({ mode, label, Icon }) => (
      <SegmentButton
        key={mode}
        type="button"
        $isActive={value === mode}
        $size={size}
        onClick={() => onChange(mode)}
        aria-pressed={value === mode}
        aria-label={label}
      >
        <Icon size={ICON_SIZE_PX[size]} />
      </SegmentButton>
    ))}
  </ToggleShell>
);

export default ViewModeToggle;
